import { render } from "./Dashboard.vue?vue&type=template&id=21e9caca"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=21e9caca&lang=scss"
script.render = render

export default script